import {
  EventName,
  type OpportunityCreatedProperties,
  type OpportunityPublishedProperties,
  type OpportunityViewedProperties,
  type OpportunitySharedProperties,
  type OpportunitiesSearchedProperties
} from '../types/events';

export function trackOpportunityCreated(
  properties: OpportunityCreatedProperties
) {
  return {
    event: EventName.OpportunityCreated,
    properties
  };
}

export function trackOpportunityPublished(
  properties: OpportunityPublishedProperties
) {
  return {
    event: EventName.OpportunityPublished,
    properties
  };
}

export function trackOpportunityViewed(
  properties: OpportunityViewedProperties
) {
  return {
    event: EventName.OpportunityViewed,
    properties
  };
}

export function trackOpportunityShared(
  properties: OpportunitySharedProperties
) {
  return {
    event: EventName.OpportunityShared,
    properties
  };
}

export function trackOpportunitySearched(
  properties: OpportunitiesSearchedProperties
) {
  return {
    event: EventName.OpportunitiesSearched,
    properties
  };
}
